import React, { Component } from "react";

class NotFound extends Component {
  render() {
    return (
      <div className="page-content container text-center">
        <h1 className="text-danger">Page not found</h1>
      </div>
    );
  }
}

export default NotFound;
